<template>
  <div class="pa-3">
    <v-row no-gutters class="px-3">
      <v-col cols="12" md="12">
        <div class="d-flex align-start">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black"
                v-bind="attrs"
                v-on="on"
                @click="$router.go(-1)"
                icon
                class="mr-3"
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h2>Gudang Belajar</h2>
        </div>
      </v-col>
    </v-row>
    <!--  ========================================================================= toolbar -->

    <div class="pa-3">
      <v-row no-gutters align="center">
        <v-col cols="12" md="5">
          <div class="pa-1 bg-green">
            <v-text-field
              placeholder="Search Gudang"
              solo
              v-model="find"
              hide-details
              dense
              prepend-inner-icon="mdi-magnify"
              flat
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="pa-2">
            <v-select
              background-color="var(--g)"
              dense
              height="46px"
              hide-details
              :items="optStatus"
              item-text="txt"
              item-value="val"
              v-model="typeContent"
              placeholder="Sort by"
              flat
              solo
              dark
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="2" v-if="listCategory.length">
          <div class="pa-2">
            <v-select
              background-color="var(--g)"
              dense
              hide-details
              :items="listCategory"
              item-text="name"
              item-value="id"
              v-model="category"
              placeholder="Category Filters"
              flat
              solo
              height="46px"
              dark
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="pa-2">
            <v-btn
              depressed
              color="#016443"
              height="46px"
              dark
              class="mr-2 px-6"
              @click="fetchData"
            >
              <h5>Search</h5>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="12" v-if="category">
          <v-btn
            depressed
            dark
            small
            rounded
            color="#3a6e5c"
            @click="
              category = '';
              fetchData();
            "
            ><v-icon small class="mr-2">mdi-close</v-icon> Reset Filter</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div>
      <div v-if="loading" class="d-flex flex-wrap my-2">
        <v-row no-gutters class="my-2">
          <v-col v-for="n in 4" :key="n" cols="12" md="3">
            <v-skeleton-loader
              class="mx-3"
              type="card"
            ></v-skeleton-loader> </v-col
        ></v-row>
      </div>
      <div v-if="dataSet && !loading">
        <v-row no-gutters class="my-2" v-if="dataSet.length">
          <v-col
            v-for="(item, n) in dataSet"
            :key="n"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <div class="pa-3">
              <v-card
                outlined
                class="pa-3 rounded-lg"
                color="#006341"
                @click="toRoute(item.id)"
              >
                <img
                  v-if="item.foto"
                  :src="item.foto"
                  class="cover_gb rounded"
                />
                <img
                  v-else
                  src="../../../assets/img/gundam/noMatrei.png"
                  class="cover_gb rounded"
                />
                <!-- <div
                  v-else
                  style="background-color: white"
                  class="d-flex align-center justify-center rounded cover_gb"
                >
                  Cover Image
                </div> -->
                <div class="mt-2 d-flex flex-column justify-spcae-between">
                  <v-tooltip
                    top
                    max-width="200px"
                    color="black"
                    nudge-top="10px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <h3
                        class="mb-1"
                        v-bind="attrs"
                        v-on="on"
                        style="color: white"
                        v-snip="1"
                      >
                        {{ item.name }}
                      </h3>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>

                  <div style="height: 40px">
                    <h5
                      v-html="item.description"
                      style="font-weight: normal; color: white"
                      v-snip="2"
                    ></h5>
                  </div>
                </div>
                <div class="mt-2 d-flex justify-space-between align-center">
                  <v-row no-gutters align="center" justify="start">
                    <v-col cols="12" md="6" sm="12">
                      <div class="d-flex align-center">
                        <star-rating
                          read-only
                          :show-rating="false"
                          :increment="0.5"
                          :star-size="20"
                          v-model="item.average_rating"
                        ></star-rating>
                        <h5
                          class="d-flex justify-end mx-2"
                          style="font-weight: normal; color: white"
                        >
                          ({{ item.average_rating.toFixed(1) }})
                        </h5>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <h5
                        class="d-flex justify-end"
                        style="font-weight: normal; color: #b3a369"
                      >
                        {{ item.category ? item.category : "" }}
                        <!-- {{ checkCategory(item.gudang_belajar_category_id) }} -->
                      </h5>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>
        <div
          v-if="!dataSet.length"
          class="d-flex flex-column justify-center align-center"
        >
          <img
            src="../../../assets/img/gundam/noGB.png"
            height="300px"
            alt=""
          />
          <h3>Data not found</h3>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
// import dialogCreate from "../../dialog/dialogMedium.vue";
import DialogSmall from "../../dialog/dialogSmall.vue";

export default {
  name: "listGudangBelajar",

  components: {
    // dialogCreate,
    StarRating,
    DialogSmall,
  },
  data() {
    return {
      loading: false,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      typeContent: "",
      category: "",
      categorySelected: [],
      optStatus: [
        { txt: "Sort by newest", val: "-created_at" },
        { txt: "Sort by oldest", val: "created_at" },
      ],
      optBookCategory: [
        { txt: "Science", val: 1 },
        { txt: "History", val: 2 },
        { txt: "Adventure", val: 3 },
      ],
      listCategory: [],

      menuLimit: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/gudang_belajar?filter[allow_ld]=1&filter[private]=0&filter[search]=${this.find}&sort=${this.typeContent}&filter[gudang_belajar_category_id]=${this.category}`,
      };
      this.$store
        .dispatch("gudang/getData", data)
        .then((data) => {
          this.fetchCategory();
          this.loading = false;
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchCategory() {
      let data = {
        path: `manage/gudang_belajar/kategori`,
      };
      this.$store
        .dispatch("gudang/getData", data)
        .then((data) => {
          this.listCategory = data.data;
          if (this.dataSet.length && this.listCategory.length) {
            this.dataSet.forEach((el) => {
              this.listCategory.forEach((cat) => {
                if (el.gudang_belajar_category_id == cat.id) {
                  el["category"] = cat.name;
                }
              });
            });
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    toRoute(id) {
      this.$router.push(`/scholar/gd/detail-gudang-belajar/${id}`);
    },
    // async addcategorySelected() {
    //   this.categorySelected = [];
    //   const index = this.optBookCategory.findIndex((object) => {
    //     return object.val === this.category;
    //   });
    //   this.categorySelected.push(this.optBookCategory[index]);
    //   this.fetchData();
    // },
    async deleteCategory(idx) {
      this.categorySelected.splice(idx, 1);
      this.category = await null;
    },
    createGudang() {
      this.d_type = "c_gudang";
      this.d_title = "Create New Data";
      this.d_create = true;
    },
    updateGudang(item) {
      this.d_type = "u_gudang";
      this.d_title = "Update Data";
      this.d_create = true;
      this.inventory = item;
    },

    deleteGudang(item) {
      this.d_type = "d_gudang";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
      this.inventory = item;
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
  },
};
</script>

<style>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
.bg-green {
  background-color: #006341;
  border-radius: 5px;
}
.cover_gb {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
</style>
